import React, { useState } from "react";
import TransitionWrapper from "../../../components/common/transition-wrapper";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";
import clsx from "clsx";
import ReactLoadingSkeleton from "react-loading-skeleton";
import IMG from "../bell3.png";
interface IProp {
  onClick: () => void;
  quantity?: number | undefined;
  title: string;
  discountPrice?: number | null | undefined;
  price?: number | null | undefined;
  distance?: number | null;
  img: string;
  isSelected: boolean;
}

export const StoreCard = ({
  quantity,
  title,
  discountPrice,
  price,
  onClick,
  img,
  distance,
  isSelected,
}: IProp): JSX.Element => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  return (
    <>
      <TransitionWrapper
        scale={0.95}
        opacity={0.9}
        className={clsx("w-full h-56", isImageLoading ? "hidden" : "block")}
        onClick={onClick}
      >
        <div className="w-full h-full">
          <div className="relative w-full h-full bg-white rounded-[12px] overflow-hidden shadow-lg">
            {/* Upper Box */}
            <div className="absolute w-full h-[9rem]">
              <div className="relative w-full h-full">
                {isImageLoading && (
                  <div className="w-full h-full absolute left-0 top-0 rounded-2xl">
                    <ReactLoadingSkeleton className="w-full h-full" />
                  </div>
                )}
                <ResponsiveCDNImage
                  src={img}
                  alt={title}
                  className="w-full h-full object-cover"
                  onLoad={() => setIsImageLoading(false)}
                />
                {/* Add a gradient overlay */}
                <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-black to-transparent opacity-30"></div>
              </div>
              <div className="flex gap-2">
                <p className="absolute bottom-2 left-4 flex items-center gap-2 font-bold text-white text-xl truncate">
                  <span className="text-white">{title}</span>
                </p>
              </div>
            </div>

            {/* Lower Box */}
            <div className="absolute w-full bottom-4 left-0 px-4 flex justify-between">
              {/* Left Box */}
              <div className="flex flex-col items-start justify-center min-w-0 flex-1 pr-4">
                <div className="flex gap-1 items-end font-semibold text-black text-lg mb-1 w-full">
                  <span className="truncate">{title} 마히팩</span>
                </div>
                <div className="flex"></div>
                <span className="text-base text-gray-500">
                  {distance
                    ? distance < 1
                      ? (distance * 1000).toFixed(0) + "m"
                      : distance.toFixed(2) + "km"
                    : ""}
                </span>
              </div>

              {/* Right Box */}
              <div className="flex flex-col items-end justify-center flex-shrink-0">
                <p className="font-bold text-gray-400 text-md line-through">
                  {price ? `${price?.toLocaleString()}원` : null}
                </p>
                <p className="font-bold text-green-600 text-2xl ml-4">
                  {discountPrice
                    ? `${discountPrice?.toLocaleString()}원`
                    : null}
                </p>
              </div>
            </div>

            {/* 선택 시 마스크 추가 */}
            {isSelected && (
              <div className="absolute inset-0 z-10 rounded-[12px] bg-black bg-opacity-30 flex justify-center items-center">
                <div className="w-[60px] h-[60px] bg-white rounded-full flex justify-center items-center">
                  <img
                    className="w-full max-w-xs h-auto"
                    src={IMG}
                    alt="Location Illustration"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </TransitionWrapper>
    </>
  );
};
